<template>
  <!--新增位置分类-->
  <addCategory></addCategory>
</template>

<script>
import addCategory from '@/components/package/addCategory.vue';
export default {
  components: {
    addCategory
  },
  name: 'addLocationCate'
};
</script>

<style scoped>

</style>
